
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`이 기능은
                    <a href="${0}">Folksonomy Engine 프로젝트</a>에서 제공됩니다. 참여하거나 피드백을 주시기 바랍니다.
`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`이 도구를 사용하면 재료 목록을 수정할 수 있습니다.
                재료 목록을 추가, 제거 또는 편집할 수 있습니다.
                <br>
                이 문자 <span class="highlight">␣</span> 는 공백을 나타냅니다.
                <br>
                이 문자 <span class="highlight">↩︎</span> 는 줄 바꿈을 나타냅니다. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `속성을 로드하는 중...`,
's000d98595e959c1e': `구글 플레이 스토어에서 다운 받을 수 있습니다`,
's013bdc8cf0d3583d': `재료 구매 도와주세요`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `작물 검증`,
's03e9c8114521b998': `재료를 편집할게요`,
's05ec315d9308091a': `바코드 모서리 아이콘`,
's061eb5af92512c85': `저장되었습니다! 다른 것도 도와주실 수 있나요?`,
's06847c221c4c0bc1': `[사용 사례를 설명]하는 속성을 만들고 싶습니다.`,
's06f6c6f99db6b552': `원래의`,
's081e2ad82db71e1d': `그룹화된 값`,
's09205907b5b56cda': `아니요`,
's0b4235aae602a950': `전담 문서`,
's0bb2d48532acc455': `CSV 다운로드`,
's0d5b7fee0311db68': `재산`,
's0fb218abc2e157ed': `이미지 무효화`,
's100c4928cc74642a': `공중보건 연구의 발전을 지원합니다.`,
's10db5498186c083b': `자르기 취소`,
's11a18a69b30b65ed': `재료 목록의 오류를 수정하는 데 도움을 주세요`,
's1205d5f6fccf8e69': `부동산 가치`,
's15d64a0a6715285a': `새로운 키`,
's166bd56d19670a72': `확대/축소`,
's19059bf0c4f7c162': `선택 영역`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `영양 정보를 수정하는 데 도움을 주세요`,
's1e00019dc454872d': `property-name 속성을 사용하여 속성 이름을 제공하세요.`,
's1e49126af0935a5b': `이 속성을 사용하는 제품 목록`,
's21e73088de6f26f3': `앱 스토어에서 다운로드 받을 수 있습니다`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `취소`,
's2db7b654c0a9bde0': `속성을 문서화하세요`,
's300b3a6ee4e1252d': str`불량 매치 ${0}%`,
's33f786bb6b4f0cf4': `자르기 결과`,
's33f85f24c0f5f008': `저장`,
's34be4af4e8fec4ae': `먼저 커뮤니티에 문의하세요`,
's36d86adc823cbfa6': `새로운 부동산을 만들기 전에 커뮤니티와 논의하세요.`,
's3781d25aa51a736c': `Folksonomy 엔진 문서`,
's383ae4449428b61e': `자르기 재설정`,
's39bcf88721a1e8ee': `선택 재설정`,
's39e14e14300694c7': `문서 및 지침`,
's3b430cfa5c1fe7f4': str`${0}에 대한 문서`,
's3f4e4b52f230a892': `이미지 캔버스`,
's417b90913e05bc17': `시사`,
's41f7dca46d3f1b4a': `값`,
's422bba9636ce2489': `중앙 이미지`,
's42dd66b2441566fd': `중앙 아이콘`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `영양소 추가하기`,
's453ab0dbb9b5c777': `오른쪽으로 크기 조절`,
's475b08749d0706ed': `전 세계 수백만 명의 소비자들이 무엇을 먹는지에 대한 정보를 얻을 수 있도록 도와주세요.`,
's49730f3d5751a433': `불러오는 중…`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `제품 개수`,
's4df2f533c0c1e7d0': `이미지 컨트롤`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `선택 항목 이동`,
's4f751fb9b3ed766c': `새로운 속성 만들기`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `부동산 이름을 입력하세요...`,
's55d7249883a98ca1': `Open Food Facts wiki에서 이 부동산에 대한 정보를 확인하세요.`,
's565867d84c04aea2': `필터 속성...`,
's5666afe5cd0166de': `확인 전 오류를 수정하거나 텍스트를 수정해 주세요.`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `제품을 로딩 중입니다...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `영양 정보를 수정하는 데 도움을 주세요.`,
's5dd6f12783fca34f': `재료 목록 편집`,
's5e8250fb85d64c23': `닫기`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `저는 지지합니다`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `수정`,
's66413c24dcf680e2': `건너뛰기`,
's67ae6594857a4d57': `귀하의 기여에 감사드립니다!`,
's6cee7cad81dfedd1': `잘린 이미지`,
's6d7b6cdedaadfb6e': `모든 기부가 소중합니다! 세계 식품 투명성 제고를 위한 여러분의 지원에 감사드립니다.`,
's7124dde792a8faa2': `안드로이드 APK`,
's718dea04853f80ae': str`좋은 매치 ${0}%`,
's71a5c9f4b68ef4d4': `수량`,
's74cb3d66f6a668e1': `선적 서류 비치`,
's787dd11bed0dc88a': `왼쪽 크기 조정`,
's7ce4fd9430e80cea': `값`,
's801a05fa8e881f37': `부동산 생성 및 가이드라인에 대해 자세히 알아보세요.`,
's8038273de2cf8b73': `자르려는 지역을 선택하세요.`,
's839cc2908a5387f2': `바코드 필터링...`,
's86197dcf3e96af64': `기존 부동산을 탐색하고 검색하세요`,
's8a63be30a129a59c': `하단 크기 조정`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `오른쪽 상단 크기 조정`,
's8db84aa4bc949af2': `새로운 속성 문서화`,
's8f839a03997a16d7': `제품 보기`,
's901ae1e236ac45d3': `삭제 취소`,
's907f7a97c6b29425': `데이터 모델이 수정될 수 있으니 주의하세요. 사용에 따른 모든 책임은 사용자에게 있습니다.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `재료 :`,
's9a7f60fce090ecaf': `속성을 불러오지 못했습니다. 나중에 다시 시도해 주세요.`,
's9b87abd68fb9df45': `키를 찾을 수 없나요? 새 키를 만드세요 {value}`,
's9c0f52425fd2f07e': `일치하지 않을 수 있습니다`,
's9fc41f789c63b40d': `제품`,
'sa1fa766e0d5634d7': `사용 가능한 점수가 없습니다`,
'sa548778b24054030': `Folksonomy Engine 프로젝트에 기여한 모든 속성을 살펴보세요. 이러한 속성은 Open Food Facts 데이터베이스의 제품에 대한 추가 메타데이터와 정보를 제공합니다.`,
'sa63907958bd0ec4b': `왼쪽 상단 크기 조정`,
'sa95b4224f685a36a': `모달 닫기`,
'sab56a1d439576fd6': `제안 아이콘`,
'sac47ea2901d04c15': `왼쪽 하단 크기 조정`,
'sb125227d436c2925': `기존 부동산 데이터베이스에서 귀하의 부동산 컨셉을 검색하세요.`,
'sb125568d43642e6f': `제품에 대한 질문에 답하세요.`,
'sb1c538e038f9b214': str`매우 잘 맞음 ${0}%`,
'sb28639570ff3b852': `모든 속성 목록`,
'sb3bdd638a58d30f4': `헌신적인 시민들로 구성된 공동체에 참여하세요.`,
'sb3cbcc1bd0fff140': `해당 속성이 존재하지 않는다는 것을 확인하고 커뮤니티에서 해당 속성이 유용하다는 데 동의하면 먼저 위키에 문서화해야 합니다.`,
'sb3d4f79d9d8b71e5': `제출`,
'sb560fa37a7bfb6c2': `이 숙박 시설에 대한 상품이 없습니다.`,
'sb7f72e4c8a2d3357': `필터 값...`,
'sb8178320160f84ea': `자르기 표시`,
'sbad7d2734149470b': `검사`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `모든 질문에 대한 답변을 받았습니다! 도와주셔서 감사합니다!`,
'sbd9a0b2293b3cd3c': `서빙 사이즈`,
'sbe472dc3c2685985': `해당 값`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `상단 크기 조정`,
'sc1c08d0cbcc3bd24': `일치하지 않습니다`,
'sc52696641af72b53': `앱을 설치하세요!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `제안된 수정 사항`,
'sc681b137e8f604f7': `삭제 확인`,
'sc6daf8a31883f8b9': `이미지 이동`,
'sc895972c88d38ca5': `폴크소노미 부동산`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `행`,
'scb3b0671d7b7f640': `새로운 가치`,
'scb489a1a173ac3f0': `예`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Slack 토론에 참여하세요`,
'scdb6cad0b92721bf': `검색된 속성이 없습니다.`,
'scf23a05631f93732': `삭제 확인`,
'scfed2f270ef6a3aa': `지역 선택`,
'sd1022bc1ef9204f7': `확대 가능한 이미지`,
'sd1077c055cf9ba6b': `제품의 성분 목록을 검증하는 데 도움을 주세요.`,
'sd698d21ddecba56b': `안녕하세요! 다음 질문에 답변해 주시면 제품 정보 개선에 도움이 됩니다.`,
'sd82bc2decefa621b': `식품 산업으로부터 독립성을 유지한다.`,
'sdb97e5976482606e': `이미 존재하는 속성인지 확인하세요`,
'sdbf806fefc584115': `당신은 찾아야합니다`,
'sdc673e73b5c13aea': `삭제`,
'sdc792b75f1edcaba': `재료의 철자를 바로잡는 데 도움을 주세요.`,
'sdca5deead576ceee': `오른쪽 하단 크기 조절`,
'sdcc2555c5dde524f': `이 항목을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.`,
'se206feec7ec57b28': `100g 당`,
'se419a9ab36987490': `무효화하다`,
'se5127cf0f92e7e48': `팁: 다음을 찾을 수도 있습니다.`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `더 나은 작물을 제안해 드릴게요`,
'seea3800e27baa686': `개별 제품`,
'sefaba4adc4ec9219': `폴크소노미 부동산`,
'seffa8ca49175b5f0': `개인화된 속성`,
'sf44a6b3b232c28ea': str`현재 값을 ${0}로 바꿉니다.`,
'sf4cd86a2f5ef2588': `제품 바코드`,
'sf57a61152168cc81': `성분 검출 오류 수정 도와주세요`,
'sf88b90b8ba23871c': `알 수 없는 일치 항목`,
'sf9aee319a006c9b4': `추가하기`,
'sfacbbe968fa7d773': `속성 이름:`,
'sfc40ea3d5d5aa6f8': `여러분의 기부금은 저희 비영리 단체의 일상적인 운영에 사용됩니다.`,
'sfe87465d50530725': `해당 값`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  